import { render, staticRenderFns } from "./content-advanced-wysiwyg-editor.vue?vue&type=template&id=3dcf98e2"
import script from "./content-advanced-wysiwyg-editor.vue?vue&type=script&lang=js"
export * from "./content-advanced-wysiwyg-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports